/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { ICreateUndoRequest } from "../shared/interfaces";

const controller = 'RichiesteAnnullamento';

const getRichiesteDiAnnullamentoInCorsoProtocollo = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/getRichiesteDiAnnullamentoInCorsoProtocollo/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addUndoRequest = (aooId: number, uorId: number, protocolId: number, createUndoRequest: ICreateUndoRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/AddUndoRequest/${protocolId}`, createUndoRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const approveUndoRequest = (aooId: number, uorId: number, protocolId: number, undoProtocolRequestId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/ApproveUndoRequest/${protocolId}`, undoProtocolRequestId, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const rejectUndoRequest = (aooId: number, uorId: number, protocolId: number, undoProtocolRequestId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/RejectUndoRequest/${protocolId}`, undoProtocolRequestId, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const checkRichiestaAnnullamentoInCorso = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/CheckRichiestaAnnullamentoInCorso/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getRichiesteDiAnnullamentoInCorsoProtocollo,
    addUndoRequest,
    approveUndoRequest,
    rejectUndoRequest,
    checkRichiestaAnnullamentoInCorso
}
